import {
  Pagination as PaginationComponent,
  usePagination,
  PaginationNext,
  PaginationPage,
  PaginationPrevious,
  PaginationContainer,
  PaginationPageGroup,
  PaginationSeparator,
} from "@ajna/pagination";
import { useColorModeValue } from "@chakra-ui/color-mode";
import { ChevronLeftIcon, ChevronRightIcon } from "@chakra-ui/icons";
import { Flex, Text, useMediaQuery } from "@chakra-ui/react";

const Pagination = ({
  meta,
  page,
  setPage,
  isDisabled,
  showTotal = true,
  showBottomTotal = false,
  size = "md",
}: any) => {
  const { currentPage, setCurrentPage, pagesCount, pages } = usePagination({
    pagesCount: meta.lastPage,
    initialState: { currentPage: page, isDisabled },
    total: meta.total,
    limits: {
      outer: 2,
      inner: 2,
    },
  });

  const to = meta.to || 0;
  const count = meta.count || 0;
  const total = meta.total || 0;

  return (
    <>
      <PaginationComponent
        pagesCount={pagesCount}
        currentPage={currentPage}
        onPageChange={setCurrentPage}
        isDisabled={isDisabled}
      >
        <PaginationContainer p="2">
          <PaginationPrevious
            mr="2"
            size={size}
            iconSpacing="0"
            leftIcon={<ChevronLeftIcon />}
            onClick={() => setPage((prev: number) => prev - 1)}
            _hover={{
              bg: "primary",
              color: "white",
            }}
          />

          <PaginationPageGroup
            separator={
              <PaginationSeparator
                size={size}
                _hover={{ bg: "gray.500" }}
                bg={useColorModeValue("white", "gray.600")}
              />
            }
          >
            {pages.map(
              (p: number) =>
                p !== undefined && (
                  <PaginationPage
                    key={`pagination_page_${p}`}
                    size={size}
                    page={p}
                    mx="1"
                    width="2rem"
                    sx={{
                      bg: page === p ? "primary" : "gray.100",
                      color: page === p ? "white" : "black",
                    }}
                    _hover={{
                      bg: "primary",
                      color: "white",
                    }}
                    onClick={() => setPage(p)}
                  />
                )
            )}
          </PaginationPageGroup>
          <PaginationNext
            ml="2"
            size={size}
            iconSpacing="0"
            rightIcon={<ChevronRightIcon />}
            onClick={() => setPage((prev: number) => prev + 1)}
            _hover={{
              bg: "primary",
              color: "white",
            }}
          />
          {!isDisabled && showTotal && !showBottomTotal && (
            <Flex ml="4" alignItems="center">
              <Text fontSize="sm" color="gray">
                Showing {to - count === 0 ? 1 : to - count} to {to} of {total}
              </Text>
            </Flex>
          )}
        </PaginationContainer>
      </PaginationComponent>
      {!isDisabled && showTotal && showBottomTotal && (
        <Flex ml="4" alignItems="center">
          <Text fontSize="sm" color="gray">
            Showing {to - count === 0 ? 1 : to - count} to {to} of {total}
          </Text>
        </Flex>
      )}
    </>
  );
};

export default Pagination;
